import React from 'react';
import Button from '../SelectValue/Button';
import Constant from '../../Constant';
import GroupIcon from '@mui/icons-material/Group';
import FlightIcon from '@mui/icons-material/Flight';
import BusinessIcon from '@mui/icons-material/Business';
import HomeIcon from '@mui/icons-material/Home';
import FadeInSection from '../FadeInSection';

function Circle() {
  const pods = [
    {
      icon: <FlightIcon fontSize="large" style={{ color: '#8046F2' }} />,
      name: 'Umrah 2026 Squad',
      badge: '3 Members • 8 Weeks In • 0.5% Bonus Unlocked',
    },
    {
      icon: <BusinessIcon fontSize="large" style={{ color: '#8046F2' }} />,
      name: 'Young Muslim Entrepreneurs',
      badge: '5 Members • 12 Weeks In • 1% Bonus Unlocked',
    },
    {
      icon: <HomeIcon fontSize="large" style={{ color: '#8046F2' }} />,
      name: 'Family Asset Builders',
      badge: '4 Members • 6 Weeks In • 0.3% Bonus Unlocked',
    },
  ];

  return (
    <FadeInSection>
    <div className="bg-white mt-16 px-6 md:p-24">
      <div className="">
        
        <h1 className="font-normal text-text-color1 md:text-[44px] mb-4 text-[24px]">
          Circle
        </h1>
        <p className="mt-4 text-[14px] sm:text-[18px] font-[400] text-text-color1">
          With Halal Wealth Circle, you don’t have to walk the journey alone. Pool resources with friends, family, or colleagues, and watch your plans come alive - secure, transparent, and halal.
        </p>
      </div>

      <div className="flex flex-col sm:flex-row gap-4 mb-8">
        <Button name="Learn More" />
        
        
      </div>

    

      
    </div>
    </FadeInSection>
  );
}

export default Circle;